export const SERVER_URL = process.env.REACT_APP_SERVER_URL;
export const ROWS_PER_PAGE = 10;
export const EUSDA_LOGO_PATH = `${process.env.PUBLIC_URL || ""}/eusda-logo.png`;
